import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { IconLibrary, SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles/enums';
import { Observable } from 'rxjs';

import { ButtonTheme, IconPosition, TagTheme } from '@fcom/ui-components';
import { SubCategory } from '@fcom/dapi/api/models/sub-category';
import { GroupedServices, RemovedServiceInfo } from '@fcom/dapi/interfaces';
import { Category } from '@fcom/dapi/api/models/category';
import { MediaQueryService } from '@fcom/common/services';
import { LoaderType } from '@fcom/common/interfaces';
import { FinnairPassengerServiceSelectionItem } from '@fcom/dapi/api/models';

import { isNotIncludedService } from '../../../../utils/common-booking.utils';

const CABIN_WEIGHT_VARIANTS = ['CABIN_WEIGHT', 'CABIN_WEIGHT_COMBINED', 'CABIN_WEIGHT_COMBINED_OLD'];

@Component({
  selector: 'fin-grouped-services',
  templateUrl: 'grouped-services.component.html',
  styleUrls: ['../../../../assets/helper-classes.scss', 'grouped-services.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GroupedServicesComponent implements OnInit {
  readonly ButtonTheme = ButtonTheme;
  readonly Category = Category;
  readonly LoaderType = LoaderType;
  readonly SvgLibraryIcon = SvgLibraryIcon;
  readonly TagTheme = TagTheme;
  readonly isNotIncludedService = isNotIncludedService;
  readonly IconPosition = IconPosition;
  readonly IconLibrary = IconLibrary;

  @Input()
  category: Category;

  @Input()
  groupedServices: GroupedServices[];

  @Input()
  loading: boolean;

  @Input()
  enableUpsellMMB: boolean = false;

  @Input()
  isCarrierConnect = false;

  @Input()
  isShoppingCart = false;

  @Input()
  isInfant: boolean;

  @Input()
  serviceRemovalInProgress: boolean;

  @Output() selectProduct: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Output() removeProduct: EventEmitter<RemovedServiceInfo> = new EventEmitter<RemovedServiceInfo>();

  @Output() continuePurchase: EventEmitter<boolean> = new EventEmitter<boolean>();

  expandOpen = false;

  filteredGroupedServices: GroupedServices[];

  cabinWeight: number;

  isMobile$: Observable<boolean>;

  constructor(private mediaQueryService: MediaQueryService) {}

  ngOnInit(): void {
    this.isMobile$ = this.mediaQueryService.isBreakpoint$('mobile');

    this.filteredGroupedServices = this.groupedServices.map((groupedService) => {
      const services = this.enableUpsellMMB
        ? groupedService.services.filter((service) => ![SubCategory.CABIN_WEIGHT].includes(service.subCategory))
        : groupedService.services;
      return {
        ...groupedService,
        services,
      };
    });

    this.cabinWeight = this.category === Category.CABIN_BAGGAGE ? this.getCabinWeight(this.groupedServices) : 0;
  }

  onSelectProduct(): void {
    this.selectProduct.emit(true);
  }

  private getCabinWeight(groupedServices: GroupedServices[]): number {
    return (
      groupedServices
        .flatMap((groupedService) => groupedService.services)
        .find((service) => CABIN_WEIGHT_VARIANTS.includes(service.variant))?.parameters?.baggageWeight ?? 0
    );
  }

  onRemoveProduct(service: FinnairPassengerServiceSelectionItem): void {
    this.removeProduct.emit({
      category: this.category,
      variant: service.variant,
      seatNumber: service.seatNumber,
    });
  }
}
